import type { AnalyticsSourceRow } from '../../executiveintel/framework';

type Props = { sources?: AnalyticsSourceRow[] };

export function UnifiedAnalyticsPanel({ sources = [] }: Props) {
  return (
    <div className="grid gap-3 grid-cols-2 sm:grid-cols-4">
      {sources.map((s) => (
        <div key={s.source} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-500">{s.source}</p>
          <p className="mt-1 text-lg font-semibold">{s.health}%</p>
          <p className="text-xs text-slate-500">{(s.records / 1000).toFixed(0)}K records</p>
        </div>
      ))}
    </div>
  );
}
